/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_mobile_analytics_app_id": "05cedc3e4afa448780f16bf6d9d5d781",
    "aws_mobile_analytics_app_region": "us-west-2",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "05cedc3e4afa448780f16bf6d9d5d781",
            "region": "us-west-2"
        }
    },
    "aws_cloud_logic_custom": [
        {
            "name": "DeleteCase",
            "endpoint": "https://2ql0gthgo4.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        },
        {
            "name": "DeletePatient",
            "endpoint": "https://m8f6zwktne.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        },
        {
            "name": "DeleteTemplate",
            "endpoint": "https://gxonbgaxl8.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        },
        {
            "name": "DeleteTemplateSection",
            "endpoint": "https://6l380cge1f.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        },
        {
            "name": "DeleteTemplateSubsection",
            "endpoint": "https://sx09s23p7k.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        },
        {
            "name": "DuplicateTemplate",
            "endpoint": "https://modscwk436.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        },
        {
            "name": "GenerateCaseTemplate",
            "endpoint": "https://8lhvj6srfg.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        },
        {
            "name": "StripeBackend",
            "endpoint": "https://5eepgvpt50.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        },
        {
            "name": "SummarizeRecording",
            "endpoint": "https://are3bzbfz3.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        },
        {
            "name": "SummarizeText",
            "endpoint": "https://pwr3avgmw2.execute-api.us-west-1.amazonaws.com/production",
            "region": "us-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://jfroj7ghsvhrfmhss3met7acfm.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-west-1:f2526e40-3edc-42aa-830a-6861c919b61d",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_NPDVY5ORN",
    "aws_user_pools_web_client_id": "21t4dnuqn62sae0trifhf2u94i",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "vetscribeamplifyexpo-storage185033-production",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
